/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserRewardsPointsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UserRewardsPointsQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename: 'LoyaltyProfile';
    readonly customerId: string;
    readonly loyaltyId: string | null;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly nameV2: Types.TierName;
    } | null;
    readonly points: {
      readonly __typename?: 'UserPointsStatus';
      readonly available: number;
    } | null;
  } | null;
};

export const UserRewardsPointsDocument = gql`
  query UserRewardsPoints {
    loyaltyProfile {
      __typename
      customerId
      loyaltyId
      tier {
        id
        nameV2
      }
      points {
        available
      }
    }
  }
`;

export function useUserRewardsPointsQuery(
  options?: Omit<Urql.UseQueryArgs<UserRewardsPointsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<UserRewardsPointsQuery, UserRewardsPointsQueryVariables>(
    { query: UserRewardsPointsDocument, ...options },
  );
}
